export default {
	init() {
		this.teamMembers = Array.from(
			document.querySelectorAll(".team-member"),
		).map((member) => ({
			el: member,
			open: false,
			toggle: member.querySelector(".team-member--toggle"),
			bio: member.querySelector(".team-member--bio"),
		}));

		this.mediaQuery = window.matchMedia("(max-width: 991px)");

		this.teamMembers.forEach((member) => {
			member.handleClick = () => {
				if (!this.mediaQuery.matches) return;

				member.open = !member.open;

				if (member.open) {
					member.bio.style.height = member.bio.scrollHeight + "px";
					member.el.classList.add("is-open");
				} else {
					member.bio.style.height = "0px";
					member.el.classList.remove("is-open");
				}
			};

			member.toggle.addEventListener("click", member.handleClick);
		});

		this.handleBreakpointChange = () => {
			this.teamMembers.forEach((member) => {
				member.open = false;
				member.el.classList.remove("is-open");
				member.bio.style.height = "";
			});
		};

		this.mediaQuery.addEventListener("change", this.handleBreakpointChange);
	},

	destroy() {
		if (this.teamMembers) {
			this.teamMembers.forEach((member) => {
				member.toggle.removeEventListener("click", member.handleClick);
				member.bio.style.height = "";
				member.el.classList.remove("is-open");
			});
		}

		if (this.mediaQuery && this.handleBreakpointChange) {
			this.mediaQuery.removeEventListener(
				"change",
				this.handleBreakpointChange,
			);
		}

		this.teamMembers = null;
		this.handleBreakpointChange = null;
		this.mediaQuery = null;
	},
};
